import React, { useEffect, useRef } from 'react';

const BarCount = 48;
const CanvasWidth = 600;
const CanvasHeight = 80;
const InactiveBarHeight = 4;

function draw_inactive_bars(ctx) {
	const bar_width = Math.floor(CanvasWidth / BarCount);
	ctx.clearRect(0, 0, CanvasWidth, CanvasHeight);
	for (let index = 0; index < BarCount; index++) {
		const x_pos = index * bar_width;
		const y_pos = (CanvasHeight / 2) - (InactiveBarHeight / 2);
		ctx.fillStyle = '#2a2a3e';
		ctx.fillRect(x_pos, y_pos, bar_width - 2, InactiveBarHeight);
	}
}

function draw_active_bars(ctx, data_array) {
	const bar_width = Math.floor(CanvasWidth / BarCount);
	const step = Math.floor(data_array.length / BarCount);
	ctx.clearRect(0, 0, CanvasWidth, CanvasHeight);
	for (let index = 0; index < BarCount; index++) {
		const value = data_array[index * step];
		const bar_height = Math.max(InactiveBarHeight, (value / 255) * CanvasHeight);
		const x_pos = index * bar_width;
		const y_pos = CanvasHeight - bar_height;
		const green = Math.min(255, 100 + Math.floor((value / 255) * 155));
		ctx.fillStyle = 'rgb(0, ' + green + ', 80)';
		ctx.fillRect(x_pos, y_pos, bar_width - 2, bar_height);
	}
}

function tick(ctx, is_active, analyser_ref, animation_ref) {
	if(!is_active || !analyser_ref.current) {
		draw_inactive_bars(ctx);
	} else {
		const data_array = new Uint8Array(analyser_ref.current.frequencyBinCount);
		analyser_ref.current.getByteFrequencyData(data_array);
		draw_active_bars(ctx, data_array);
	}
	animation_ref.current = requestAnimationFrame(tick.bind(null, ctx, is_active, analyser_ref, animation_ref));
}

function AudioVisualizer({ analyser_ref, is_active }) {
	const canvas_ref = useRef(null);
	const animation_ref = useRef(null);

	useEffect(() => {
		const canvas = canvas_ref.current;
		if(!canvas) {
			return;
		}
		const ctx = canvas.getContext('2d');
		animation_ref.current = requestAnimationFrame(tick.bind(null, ctx, is_active, analyser_ref, animation_ref));
		return function() {
			if(animation_ref.current) {
				cancelAnimationFrame(animation_ref.current);
			}
		};
	}, [is_active, analyser_ref]);

	return (
		<canvas
			ref={canvas_ref}
			className="audio-visualizer"
			width={CanvasWidth}
			height={CanvasHeight}
		/>
	);
}

export default AudioVisualizer;
